/**
 * ============================================================
 * API CLIENT - single shared instance
 * ============================================================
 * Replaces supabaseClient.js. Every call attaches the stored JWT as a
 * Bearer token; the backend is the only thing that talks to Postgres now.
 */

const API_BASE = process.env.REACT_APP_API_BASE || "";
const TOKEN_KEY = "auth_token";

class ConflictError extends Error {
  constructor(current) {
    super("Version conflict");
    this.isConflict = true;
    this.current = current;
  }
}

async function request(path, options = {}) {
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (res.status === 409) {
    const body = await res.json();
    throw new ConflictError(body.current);
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return null;
  const body = await res.json();
  return body.data;
}

export const apiClient = {
  getRoster: () => request("/api/roster"),
  createFreelancer: (data) => request("/api/roster", { method: "POST", body: JSON.stringify(data) }),
  updateFreelancer: (data, expectedVersion) =>
    request(`/api/roster/${data.id}`, { method: "PATCH", body: JSON.stringify({ ...data, expectedVersion }) }),
  deleteFreelancer: (id) => request(`/api/roster/${id}`, { method: "DELETE" }),
  getSetting: (key) => request(`/api/settings/${key}`),
  putSetting: (key, value) => request(`/api/settings/${key}`, { method: "PUT", body: JSON.stringify({ value }) }),
  recommend: (messages) => request("/api/recommend", { method: "POST", body: JSON.stringify({ messages }) }),
};
